import { render, staticRenderFns } from "./VueIntegerPlusMinus.vue?vue&type=template&id=a97588f2&scoped=true&"
import script from "./VueIntegerPlusMinus.vue?vue&type=script&lang=js&"
export * from "./VueIntegerPlusMinus.vue?vue&type=script&lang=js&"
import style0 from "./VueIntegerPlusMinus.vue?vue&type=style&index=0&id=a97588f2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97588f2",
  null
  
)

export default component.exports